import { Box } from "@mui/material";
export const ClipboardIcon = () => <Box component="img" src="/images/icons/clipboard.svg"/>;
